<template>
	<div class="block-view">
		<div v-if="label" class="block-view__label">{{ label }}</div>
		<div class="block-view__value">
			<slot>{{ (text === null || text === undefined || text === '') ? '—' : text }}</slot>
		</div>
	</div>
</template>

<script>
/**
 * Labelled multi-line text block. Unlike ReadView (which is a 52px single-line
 * ellipsised row), BlockView wraps and grows with its content — use it for
 * paragraph-style values like summaries, explanations, and free-form text.
 */
export default {
	props: {
		label: String,
		text: [String, Number]
	}
};
</script>

<style lang="scss" scoped>
.block-view {
	&__label {
		font-size: 11px;
		color: #888;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		margin-bottom: 6px;
	}

	&__value {
		font-size: 14px;
		line-height: 1.5;
		white-space: pre-wrap;
		word-break: break-word;
		color: white;
	}
}
</style>
